module.exports = __webpack_public_path__ + "static/media/pycharm-plain.3d19ed2e.svg";